import { ErrorBoundary } from '@/pages/Company/procedures/free-time/policies/policies.error';

export default ErrorBoundary;
